module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/102bfa6b6978940ca3d8d942e3b31097.svg";